<button type="button" class="btn btn-link btn-sm p-0 d-inline align-baseline person-link" (click)="openPersonModal()">
    {{merchantAccount.contact.displayName}}
</button>